import { ReactElement } from "react";
import { GlobalSearchScopeIdentifier, KnowledgeItemGlobalSearchResultItem } from "client/Api/TitleBar/GlobalSearch/globalSearch";
import { Highlight } from "client/Components";
import { generateTrackingId } from "client/Misc/utils";
import { useHighlights } from "./useHighlights";
import { TimeZone } from "client/DateAndTime/timezones";
import { KnowledgeItemListItem } from "client/Features/Hub/KnowledgeItems/ListItem/KnowledgeItemListItem";
import { GlobalSearchItem } from "../../../GlobalSearchItem/GlobalSearchItem";
import { useKnowledgeItemNavigationHandler } from "../../../Navigation/useKnowledgeItemNavigationHandler";

export type KnowledgeItemItemViewProps = {
	item: KnowledgeItemGlobalSearchResultItem;
	itemIndex: number;
	itemScope: GlobalSearchScopeIdentifier;
	timezone: TimeZone;
	tabIndex: number;
};

export const KnowledgeItemItemView = (props: KnowledgeItemItemViewProps): ReactElement => {
	const {
		item,
		itemIndex,
		itemScope,
		timezone,
		tabIndex
	} = props;

	const highlights: Map<string, Highlight> = useHighlights(item.hitHighlights);

	const {
	 	id,
		title,
		category,
		author,
		lastModifiedDate,
		media
	} = item.knowledgeItem;

	const openHandler: () => void = useKnowledgeItemNavigationHandler({
		id,
		searchResult: item,
		itemScope
	});

	return (
		<GlobalSearchItem
			trackingId={generateTrackingId("knowledge-item", `|${id}`)}
			onClick={openHandler}
		>
			<KnowledgeItemListItem
				title={title}
				categoryName={category?.name}
				authorName={author?.name}
				lastModifiedDate={lastModifiedDate}
				media={media}
				timezone={timezone}
				trackingId={generateTrackingId("knowledge-item-result-list-item", `|${id}`)}
				highlights={{ title: highlights.get("knowledgeItem.title") }}
				itemIndex={itemIndex}
				tabIndex={tabIndex}
				onExecute={openHandler}
			/>
		</GlobalSearchItem>
	);
};

KnowledgeItemItemView.displayName = "KnowledgeItemItemView";
